import React from 'react';
import styled from 'styled-components';
import { SortableContainer } from 'react-sortable-hoc';

import { BakedBreadEntity } from 'src/firebase/db/BakedBreads';
import { ShopEntity } from 'src/firebase/db/Shops';

import BakedBreadListItem from 'src/components/molecules/list/BakedBreadListItem';

type Props = {
  items: BakedBreadEntity[];
  shop: ShopEntity;
  query: string;
  bakedBreadTag: string;
  listType: string;
  disabledSort: boolean;
};

const BakedBreadList = SortableContainer((props: Props) => {
  const { items, shop, query, bakedBreadTag, listType, disabledSort } = props;

  return (
    <Container>
      {items.map((item) => (
        <BakedBreadListItem
          key={`BakedBreadListItem|${item.id}|${item.order}`}
          index={item.order}
          item={item}
          shop={shop}
          disabled={disabledSort}
          query={query}
          bakedBreadTag={bakedBreadTag}
          listType={listType}
        />
      ))}
    </Container>
  );
});

const Container = styled.ul``;

export default BakedBreadList;
